const DOMAIN = 'tajirbd.com';
// Every vendor's admin panel lives on this one subdomain (admin.tajirbd.com / admin.localhost).
// Reserved: no storefront can use it, so no vendor may have the username "admin".
const ADMIN_SUB = 'admin';

function extractSub(host, base) {
  const sub = host.slice(0, host.length - base.length - 1);
  if (sub === ADMIN_SUB) {
    return { type: 'admin', slug: null };
  }
  return { type: 'storefront', slug: sub };
}

function isLocalHost(host) {
  return host === 'localhost' || host === '127.0.0.1' || host.endsWith('.localhost');
}

export function parseSubdomain() {
  const host = window.location.hostname;

  if (host === 'localhost' || host === '127.0.0.1') {
    return { type: 'landing', slug: null };
  }

  if (host.endsWith(`.localhost`)) {
    return extractSub(host, 'localhost');
  }

  if (host === DOMAIN || host === `www.${DOMAIN}`) {
    return { type: 'landing', slug: null };
  }

  if (host.endsWith(`.${DOMAIN}`)) {
    return extractSub(host, DOMAIN);
  }

  // Any other host (Vercel preview URLs, IPs) serves the admin panel.
  return { type: 'admin', slug: null };
}

// Where the admin panel is, as seen from the current site (landing page links here).
export function adminUrl() {
  const { protocol, hostname, port } = window.location;
  if (isLocalHost(hostname)) {
    return `${protocol}//${ADMIN_SUB}.localhost${port ? `:${port}` : ''}`;
  }
  return `https://${ADMIN_SUB}.${DOMAIN}`;
}
